import { LitheFC, LitheSpecificElement } from '@wheelbox/lithejs-engine';
import { goto } from '@wheelbox/lithejs-router';
import withTranslations from '@wheelbox/lithejs-i18n';

import {
  NavigationMenu,
  NavigationMenuList,
  NavigationMenuItem,
  NavigationMenuLink,
} from '@components/ui';

interface NavItem {
  path: string;
  labelKey: string;
}

const navItems: NavItem[] = [
  { path: '/tutorial', labelKey: 'nav.tutorial' },
  { path: '/docs', labelKey: 'nav.docs' },
  { path: '/examples', labelKey: 'nav.examples' },
  { path: '/blog', labelKey: 'nav.blog' },
];

const AppMenu: LitheFC = ({
  id = 'app-menu',
  testId = 'app-menu',
}): LitheSpecificElement => {
  const t = withTranslations('Common');

  return NavigationMenu(
    {
      id,
      testId,
      classes: 'hidden md:flex ml-4 justify-start',
    },
    NavigationMenuList(
      { classes: 'gap-1 justify-start' },
      ...navItems.map((item) =>
        NavigationMenuItem(
          { value: item.path },
          NavigationMenuLink(
            {
              classes: 'px-4 py-2',
              onclick: (e: MouseEvent) => {
                e.preventDefault();
                goto(item.path);
              },
            },
            t(item.labelKey)
          )
        )
      )
    )
  );
};

export default AppMenu;
